module.exports = __webpack_public_path__ + "img/logo-topdoctors-vectores-chile-white.14b69526.svg";